import { render, staticRenderFns } from "./pesoParaLaEdadNinas0a2A.vue?vue&type=template&id=47458796&scoped=true"
import script from "./pesoParaLaEdadNinas0a2A.vue?vue&type=script&lang=js"
export * from "./pesoParaLaEdadNinas0a2A.vue?vue&type=script&lang=js"
import style0 from "./pesoParaLaEdadNinas0a2A.vue?vue&type=style&index=0&id=47458796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47458796",
  null
  
)

export default component.exports